import React, { Component } from "react";
import { Route, Routes, Switch } from "react-router-dom";
import { Layout } from "antd";
import UserList from "../pages/user/UserList";
import NoticeList from "../pages/notice/NoticeList";
import DepositRequestList from "../pages/transaction/DepositRequestList";
import TransferRequestList from "../pages/transaction/TransferRequestList";
import DepositList from "../pages/transaction/DepositList";
import WithdrawList from "../pages/transaction/WithdrawList";
import ParentTransactionList from "../pages/transaction/ParentTransactionList";
import AssetWithdraw from "../pages/setting/AssetWithdraw";
import AdminInfo from "../pages/admin/AdminInfo";
import CompanyInfo from "../pages/admin/CompanyInfo";
import AdminLoginLog from "../pages/log/AdminLoginLog";
import MergeList from "../pages/wallet/MergeList";
import MergeLogList from "../pages/wallet/MergeLogList";
import EthLogList from "../pages/wallet/EthLogList";

const Content =()=> {
    return (
          <Routes>
            {/* Transaction */}
            {/* 입금신청내역 */}
            <Route path="/DepositRequestList" element={<DepositRequestList />} />
            {/* 출금신청내역 */}
            <Route path="/TransferRequestList" element={<TransferRequestList />} />
            {/* 입금내역 */}
            <Route path="/DepositList" element={<DepositList />} />
            {/* 출금내역 */}
            <Route path="/WithdrawList" element={<WithdrawList />} />
            {/* 집금계좌 거래내역 */}
            <Route path="/ParentTransactionList" element={<ParentTransactionList />} />
            
             {/* Wallet */}
            {/* 지갑모으기 */}
            <Route path="/MergeList" element={<MergeList />} />
            {/* 모으기내역 */}
            <Route path="/MergeLogList" element={<MergeLogList />} />
            {/* 수수료지급내역 */}
            <Route path="/EthLogList" element={<EthLogList />} />

            {/* Setting */}
            {/* 자산인출 */}
            <Route path="/AssetWithdraw" element={<AssetWithdraw />} />
            
            {/* Admin */}
            {/* 관리자정보 */}
            <Route path="/AdminInfo" element={<AdminInfo />} />
            {/* 업체정보 */}
            <Route path="/CompanyInfo" element={<CompanyInfo />} />
            
            {/* log */}
            {/* 로그인 로그 */}<Route path="/AdminLoginLog" element={<AdminLoginLog />} />

            {/* user */}
            {/* 유저 목록 */}<Route path="/UserList" element={<UserList />} />
          </Routes>
    );

}
export default Content;